module.exports = __webpack_public_path__ + "img/otrosrecursos1.c2092ccc.png";